// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsIncluded {
  width: 100% !important;
  padding: 50px 0px !important;
  background-color: #ba1e24;
  text-align: center;
  margin: 0px;
  margin-top: 50px;
}

.whatsIncluded>h1 {
  color: #fff;
  font-size: clamp(35px, 4vw, 54px) !important;
  font-weight: 700;
  margin-bottom: 20px;
}

.whatsIncluded>p {
  color: #fff !important;
  text-align: center;
  font-size: clamp(16px, 4vw, 20px) !important;
  margin-bottom: 0px !important;
  font-family: lightThicker !important;
}

.whatsIncluded>button {
  margin-top: 60px;
  color: #fff;
  font-size: clamp(18px, 4vw, 24px) !important;
  font-weight: 600;
  padding: 10px 20px;
  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;
  border: none;
  cursor: pointer;
}

.header {
  width: 100%;
  margin: auto;
}

.whatsIncludedContainer {
  width: 80%;
  margin: 20px auto;
}

.whatsIncludedContainer>h2 {
  color: #ba1e24;
  font-size: clamp(20px, 4vw, 24px) !important;
  font-weight: 400;
}

.whatsIncludedContainer>h1 {
  color: #000;
  font-size: clamp(30px, 4vw, 54px) !important;
  font-weight: 600;
  margin-top: 30px;
}

.whatsIncludedContainer>p {
  color: #000;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-style: normal;
  font-family: lightThicker !important;
  margin: 20px auto !important;
  margin-bottom: 50px !important;
}

.black,
.white {
  position: sticky;
  top: 0;
  padding: 60px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.whiteLast {
  padding: 60px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.black {
  background-color: #262626;
  color: #fff;
}

.black>div,
.white>div,
.whiteLast>div {
  width: 40%;
}

.black>div:nth-child(2),
.white>div:nth-child(2),
.whiteLast>div:nth-child(2) {
  width: 30% !important;
}

.imageContainer {
  display: flex !important;
  justify-content: center !important;
}

.black>div>p,
.white>div>p,
.whiteLast>div>p {
  font-family: lightThicker !important;
  font-size: clamp(14px, 4vw, 18px) !important;
  font-weight: 400 !important;
}

.black>div>h1,
.white>div>h1,
.whiteLast>div>h1 {
  width: fit-content;
  border-bottom: 4px solid #ba1e24;
  font-size: clamp(25px, 4vw, 32px);
}

.white,
.whiteLast {
  background-color: #fff;
  color: #000;
}

@media screen and (max-width: 1200px) {
  .header {
    width: 90%;
  }

  .whatsIncludedContainer {
    width: 90%;
  }

  .black>div>img,
  .white>div>img,
  .whiteLast>div>img {
    height: 200px;
    object-fit: contain;
  }

  .black>div:nth-child(2),
  .white>div:nth-child(2),
  .whiteLast>div:nth-child(2) {
    width: 50% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1000px) {
  .banner-heading {
    font-size: 20px !important;
  }  
  .banner-subheading {
    font-size:10px;
  }
  .findrace-button button {
    width: 189px;
    height: 40px;
  }


}
@media screen and (min-width: 1000px) and (max-width: 1300px) {
  .banner-heading {
    font-size: 30px !important;
  }  
  .banner-subheading {
    font-size:16px;
  }
}
@media screen and (max-width: 600px) {
  .whatsIncludedContainer>p {
    margin-bottom: 20px !important;
  }

  .whatsIncluded {
    padding: 20px 0px !important;
  }

  .whatsIncluded>button {
    margin-top: 30px;
    padding: 5px 20px;
  }

  .black>div>img,
  .white>div>img,
  .whiteLast>div>img {
    height: 150px;
    width: 100px;
    object-fit: contain;
  }

  .black>div:nth-child(2),
  .white>div:nth-child(2),
  .whiteLast>div:nth-child(2) {
    width: 50% !important;
  }

  .whatsIncluded {
    margin-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/whatsIncluded/whatsIncluded.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;;EAGE,oCAAoC;EACpC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;;;EAGE,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,YAAY;EACd;;;AAGF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;IAGE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".whatsIncluded {\n  width: 100% !important;\n  padding: 50px 0px !important;\n  background-color: #ba1e24;\n  text-align: center;\n  margin: 0px;\n  margin-top: 50px;\n}\n\n.whatsIncluded>h1 {\n  color: #fff;\n  font-size: clamp(35px, 4vw, 54px) !important;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.whatsIncluded>p {\n  color: #fff !important;\n  text-align: center;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  margin-bottom: 0px !important;\n  font-family: lightThicker !important;\n}\n\n.whatsIncluded>button {\n  margin-top: 60px;\n  color: #fff;\n  font-size: clamp(18px, 4vw, 24px) !important;\n  font-weight: 600;\n  padding: 10px 20px;\n  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.header {\n  width: 100%;\n  margin: auto;\n}\n\n.whatsIncludedContainer {\n  width: 80%;\n  margin: 20px auto;\n}\n\n.whatsIncludedContainer>h2 {\n  color: #ba1e24;\n  font-size: clamp(20px, 4vw, 24px) !important;\n  font-weight: 400;\n}\n\n.whatsIncludedContainer>h1 {\n  color: #000;\n  font-size: clamp(30px, 4vw, 54px) !important;\n  font-weight: 600;\n  margin-top: 30px;\n}\n\n.whatsIncludedContainer>p {\n  color: #000;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-style: normal;\n  font-family: lightThicker !important;\n  margin: 20px auto !important;\n  margin-bottom: 50px !important;\n}\n\n.black,\n.white {\n  position: sticky;\n  top: 0;\n  padding: 60px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.whiteLast {\n  padding: 60px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.black {\n  background-color: #262626;\n  color: #fff;\n}\n\n.black>div,\n.white>div,\n.whiteLast>div {\n  width: 40%;\n}\n\n.black>div:nth-child(2),\n.white>div:nth-child(2),\n.whiteLast>div:nth-child(2) {\n  width: 30% !important;\n}\n\n.imageContainer {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.black>div>p,\n.white>div>p,\n.whiteLast>div>p {\n  font-family: lightThicker !important;\n  font-size: clamp(14px, 4vw, 18px) !important;\n  font-weight: 400 !important;\n}\n\n.black>div>h1,\n.white>div>h1,\n.whiteLast>div>h1 {\n  width: fit-content;\n  border-bottom: 4px solid #ba1e24;\n  font-size: clamp(25px, 4vw, 32px);\n}\n\n.white,\n.whiteLast {\n  background-color: #fff;\n  color: #000;\n}\n\n@media screen and (max-width: 1200px) {\n  .header {\n    width: 90%;\n  }\n\n  .whatsIncludedContainer {\n    width: 90%;\n  }\n\n  .black>div>img,\n  .white>div>img,\n  .whiteLast>div>img {\n    height: 200px;\n    object-fit: contain;\n  }\n\n  .black>div:nth-child(2),\n  .white>div:nth-child(2),\n  .whiteLast>div:nth-child(2) {\n    width: 50% !important;\n  }\n}\n@media screen and (min-width: 600px) and (max-width: 1000px) {\n  .banner-heading {\n    font-size: 20px !important;\n  }  \n  .banner-subheading {\n    font-size:10px;\n  }\n  .findrace-button button {\n    width: 189px;\n    height: 40px;\n  }\n\n\n}\n@media screen and (min-width: 1000px) and (max-width: 1300px) {\n  .banner-heading {\n    font-size: 30px !important;\n  }  \n  .banner-subheading {\n    font-size:16px;\n  }\n}\n@media screen and (max-width: 600px) {\n  .whatsIncludedContainer>p {\n    margin-bottom: 20px !important;\n  }\n\n  .whatsIncluded {\n    padding: 20px 0px !important;\n  }\n\n  .whatsIncluded>button {\n    margin-top: 30px;\n    padding: 5px 20px;\n  }\n\n  .black>div>img,\n  .white>div>img,\n  .whiteLast>div>img {\n    height: 150px;\n    width: 100px;\n    object-fit: contain;\n  }\n\n  .black>div:nth-child(2),\n  .white>div:nth-child(2),\n  .whiteLast>div:nth-child(2) {\n    width: 50% !important;\n  }\n\n  .whatsIncluded {\n    margin-top: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
